import React from "react";

export const BlogsPdfUpdate = () => {
  return <div>BlogsPdfUpdate</div>;
};
